import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import FleetPerformanceDashboard from './pages/fleet-performance-dashboard';
import OperationsCommandCenter from './pages/operations-command-center';
import ExecutiveSummaryDashboard from './pages/executive-summary-dashboard';
import SustainabilityAnalyticsHub from './pages/sustainability-analytics-hub';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<ExecutiveSummaryDashboard />} />
        <Route path="/fleet-performance-dashboard" element={<FleetPerformanceDashboard />} />
        <Route path="/operations-command-center" element={<OperationsCommandCenter />} />
        <Route path="/executive-summary-dashboard" element={<ExecutiveSummaryDashboard />} />
        <Route path="/sustainability-analytics-hub" element={<SustainabilityAnalyticsHub />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
